// extracted by mini-css-extract-plugin
export default {"card":"FeatureCard_card__s-FnW","photo":"FeatureCard_photo__eb7JO","more":"FeatureCard_more__uHwZD"};